<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
  import Pagination from "../../molecules/Pagination.svelte";
  import Table from "../../molecules/Table.svelte";
  import type { RecruitmentService } from "../../services/recruitment.service";

  export let klass = "";
  export let service: RecruitmentService;
  const label = "求人一覧";

  let models = service.store.models;
  let tableHeaders = service.store.tableHeaders;
  let page = service.store.page;
  let size = service.store.size;

  onMount(async () => {
    await service.getList();
  });
</script>

<div class={klass}>
  <SectionBoard>
    <h2 class="font-semibold">
      {label}
    </h2>

    <Pagination
      page={$page}
      result={$size}
      next={service.handleNext}
      previous={service.handlePrevious}
      klass="mt-4"
    />

    <Table
      klass="mt-2"
      headers={$tableHeaders}
      items={$tableHeaders}
      rows={$models}
      selectRow={service.goEditPage}
      asLink={true}
    />

    <Pagination
      page={$page}
      result={$size}
      next={service.handleNext}
      previous={service.handlePrevious}
      klass="mt-4"
    />
  </SectionBoard>
</div>
